import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useMemo, useCallback } from 'react';
import { useThemeProps } from '@mui/material';
import { formatTime } from './formatters.js';
import usePreferenceValue$1 from '../../../cinnamon-core/es/components/preferences/usePreferenceValue.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var componentRoot = createComponentSlot({
  name: "CinUseTimeFormatter",
  slot: "Root"
});
/**
 * A hook to format a value as a time
 * @returns {function} A formatter function that receives a value and returns a formatted string
 */

var useTimeFormatter = function useTimeFormatter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _usePreferenceValue = usePreferenceValue$1("timezone"),
      _usePreferenceValue2 = _slicedToArray(_usePreferenceValue, 1),
      preferenceTimezone = _usePreferenceValue2[0];

  var themeOptions = useThemeProps({
    props: {},
    name: componentRoot.name
  });
  var formatterOptions = useMemo(function () {
    return _objectSpread2({}, options);
  }, Object.values(options));

  var format = function format(value) {
    var _formatTime;

    var overrideOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (_formatTime = formatTime(value, _objectSpread2(_objectSpread2(_objectSpread2({
      timezone: preferenceTimezone,
      defaultZone: preferenceTimezone
    }, themeOptions), formatterOptions), overrideOptions))) !== null && _formatTime !== void 0 ? _formatTime : "";
  };

  return useCallback(format, [themeOptions, formatterOptions]);
};

var useTimeFormatter$1 = useTimeFormatter;

export { useTimeFormatter$1 as default };
